import { useEffect, useState } from "react";

import { useOutletContext } from "react-router-dom";

import { isObject } from "lodash";

const checkMockup = process.env.REACT_APP_IS_MOCKUP;

const useAuthScope = () => {
  const { scopeReady } = useOutletContext();

  const [auth, setAuth] = useState({
    scopeLevel: null,
    realm: null,
    orgs: null,
    sites: null,
    permissions: null,
  });

  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    if (scopeReady || checkMockup === "true") {
      const storage = localStorage.getItem("selectBreadcrumbs");
      if (!storage) {
        setIsAuthReady(true);
        return;
      }

      const { realm, orgs, site } = JSON.parse(storage);

      if (isObject(site) && Object.keys(site).length > 0) {
        setAuth((prev) => ({
          ...prev,
          scopeLevel: "site",
          realm,
          orgs,
          sites: site,
          permissions: site.roleName,
        }));
      } else {
        const currentPermissions = realm?.roleName || orgs?.roleName || "";

        setAuth((prev) => ({
          ...prev,
          scopeLevel: "org",
          realm,
          orgs,
          permissions: currentPermissions,
        }));
      }

      setIsAuthReady(true);
    }
    if (scopeReady === false && checkMockup === "false") {
      setIsAuthReady(false);
    }
  }, [scopeReady, checkMockup]);

  return {
    auth,
    standalone: isAuthReady ? (!auth.orgs || Object.keys(auth.orgs).length === 0) : null,
    isAuthReady,
  };
};

export default useAuthScope;
